export default __webpack_public_path__ + "static/media/carne1.aa082e53.jpg";